const numberReducer = (num) => {
  if (num < 10) return num

  const sum = [...num.toString()].map(Number).reduce((acc, cv) => acc + cv)
  return numberReducer(sum)
}

const sum = (arr) => arr.reduce((acc, cv) => acc + cv)

function isValidVatNumber(vat) {
  const validators = [1, 2, 1, 2, 1, 2, 4, 1]

  const checkSum = [...vat].map((v, i) => {
    let result = Number(v) * validators[i]
    return numberReducer(result)
  })

  if (vat[6] !== "7") {
    return sum(checkSum) % 5 === 0
  } else {
    checkSum[6] = 0
    return sum(checkSum) % 5 === 0 || sum(checkSum) % 5 === 1
  }
}

export const VatValidator = () => ({
  vat: "",
  error: "",
  isValid: true,
  isDefault: false,

  init() {
    this.vat = this.$refs.vatInput.value
    this.isDefault = this.$el.querySelector('input[type="checkbox"]')?.checked || false

    this.validate()

    this.$nextTick(() => {
      this.$dispatch("vat-validation-changed", { isValid: this.isValid, isDefault: this.isDefault })
    })
  },

  changeVat() {
    this.vat = this.$refs.vatInput.value
    this.validate()

    this.$dispatch("vat-validation-changed", { isValid: this.isValid, isDefault: this.isDefault })
  },

  toggleDefault() {
    this.isDefault = !this.isDefault
    this.validate()

    this.$dispatch("vat-validation-changed", { isValid: this.isValid, isDefault: this.isDefault })
  },

  validate() {
    this.isValid = true
    this.error = ""

    if (this.isDefault && (!this.vat || this.vat.trim() === "")) {
      this.error = "預設選項不能為空"
      this.isValid = false
      return
    }

    if (!this.isDefault && (!this.vat || this.vat.trim() === "")) {
      return
    }

    if (this.vat && this.vat.trim() !== "") {
      // 統一編號為8碼數字
      const vatRegex = /^\d{8}$/

      if (!vatRegex.test(this.vat)) {
        this.error = "統一編號必須為8碼數字"
        this.isValid = false
        return
      }

      // 驗證統一編號
      if (!isValidVatNumber(this.vat)) {
        this.error = "統一編號格式不正確"
        this.isValid = false
      }
    }
  },
})
